import React from 'react';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import FormBaixas from './FormBaixas';

function DialogBaixas({
    open,
    onClose,

    itens,
    isLoading,
    isSubmitting,
    selectedBaixas,
    setSelectedBaixas,

    openConfirm,
    setOpenConfirm,

    handleConfirmEstorno,
    handleEstornarSelecionadas,
    handleEstornarUma,
}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
            <DialogTitle
                sx={{
                    bgcolor: '#f5f5f5',
                    color: '#222',
                    fontWeight: 700,
                    borderBottom: '1px solid #ddd',
                }}
            >
                Baixas do Lançamento
            </DialogTitle>

            <DialogContent dividers>
                <FormBaixas
                    itens={itens}
                    isLoading={isLoading}
                    isSubmitting={isSubmitting}
                    selectedBaixas={selectedBaixas}
                    setSelectedBaixas={setSelectedBaixas}
                    openConfirm={openConfirm}
                    setOpenConfirm={setOpenConfirm}
                    handleConfirmEstorno={handleConfirmEstorno}
                    handleEstornarSelecionadas={handleEstornarSelecionadas}
                    handleEstornarUma={handleEstornarUma}
                    onClose={onClose}
                />
            </DialogContent>
        </Dialog>
    );
}

export default DialogBaixas;
